/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marker_Import_New_Group_Name_LabelInputs */



/**
* | output |
* | --- |
* | "New Group Name" |
*
* @param {Marker_Import_New_Group_Name_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const marker_import_new_group_name_label = /** @type {((inputs?: Marker_Import_New_Group_Name_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Import_New_Group_Name_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Nom du nouveau groupe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Neuer Gruppenname")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nuovo nome del gruppo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Новое название группы")
	if (locale === "es") return /** @type {LocalizedString} */ ("Nuevo nombre del grupo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("新组名")
	if (locale === "ja") return /** @type {LocalizedString} */ ("新しいグループ名")
	if (locale === "hi") return /** @type {LocalizedString} */ ("नए समूह का नाम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Novo nome do grupo")
	return /** @type {LocalizedString} */ ("New Group Name")
});